export default [
  {
    path: '/admin/inventory-lists',
    name: 'inventory-list',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/inventory-list/index.vue')
  },
  {
    path: '/admin/summary-inventory-lists',
    name: 'inventory-list',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/inventory-list/summary.vue')
  }
]
